<script>
import _ from "lodash";
import Qs from "qs";
import Lockr from "lockr";
import BaseFilters from "../base-filters.vue";
import Api from "@/store/jsonapi";
import countries from "i18n-iso-countries";
import config from "../../config/index";
import { mapState } from "vuex";

export default {
  extends: BaseFilters,
  data: function () {
    let filters = [
      {
        name: this.$i18n.t("all"),
        conditions: [],
        built_in: true,
      },
      {
        name: "Legacy Plans",
        built_in: true,
        conditions: [
          {
            attr: "plan_generation",
            op: { val: "=", label: this.$t("equal") },
            value: {
              val: 1,
              label: "Legacy",
            },
          },
        ],
      },
      {
        name: "Next Gen Plans",
        built_in: true,
        conditions: [
          {
            attr: "plan_generation",
            op: { val: "=", label: this.$t("equal") },
            value: {
              val: 2,
              label: "Current",
            },
          },
        ],
      },
      {
        name: "Open Quote",
        built_in: true,
        conditions: [
          {
            attr: "has_quote",
            op: { val: "=", label: this.$t("equal") },
            value: {
              val: true,
              label: this.$t("true"),
            },
          },
        ],
      },
      {
        name: this.$i18n.t("overdue_invoices"),
        built_in: true,
        conditions: [
          {
            attr: "payment_extras",
            op: { val: "=", label: this.$t("equal") },
            value: {
              val: "has_overdue_invoices",
              label: this.$t("true"),
            },
          },
        ],
      },
      {
        name: this.$i18n.t("missing_credit_card"),
        built_in: true,
        conditions: [
          {
            attr: "payment_extras",
            op: { val: "=", label: this.$t("equal") },
            value: {
              val: "missing_credit_card",
              label: this.$t("missing_credit_card"),
            },
          },
        ],
      },
      {
        name: this.$i18n.t("unknown"),
        built_in: true,
        conditions: [
          {
            attr: "onboarding_status",
            op: { val: "=", label: this.$t("equal") },
            value: {
              val: "unknown",
              label: this.$t("unknown"),
            },
          },
        ],
      },
    ];

    if (this.can("read_organizations")) {
      filters.unshift({
        name: this.$store.state.currentOrganization.name,
        conditions: [
          {
            attr: "organization",
            op: { val: "=", label: this.$t("equal") },
            value: {
              val: this.$store.state.currentOrganization.id,
              label: this.$store.state.currentOrganization.name,
            },
          },
        ],
      });
    }

    return {
      group: "backend-customers",
      carriers: [],
      order_channels: [],
      plans: [],
      tags: [],
      users: [],
      countries: [],
      organizations: [],
      built_in_filters: filters,
    };
  },
  computed: {
    attributes() {
      let attrs = [
        {
          name: "service_status",
          type: "Array",
          value: [
            {
              val: "running",
              label: this.$t("running"),
            },
            {
              val: "test",
              label: this.$t("test"),
            },
            {
              val: "disabled",
              label: this.$t("disabled"),
            },
            {
              val: "free_trial",
              label: this.$t("free_trial"),
            },
          ],
        },
        {
          name: "subscription_status",
          type: "Array",
          value: [
            {
              val: "active",
              label: this.$t("active"),
            },
            {
              val: "trial",
              label: this.$t("trial"),
            },
            {
              val: "cancelled",
              label: this.$t("cancelled"),
            },
          ],
        },
        {
          name: "has_quote",
          type: "Array",
          value: [
            {
              val: true,
              label: this.$t("true"),
            },
            {
              val: false,
              label: this.$t("false"),
            },
          ],
        },
        {
          name: "onboarding_status",
          type: "Array",
          value: [
            {
              val: "onboarding",
              label: this.$t("onboarding"),
            },
            {
              val: "migrating",
              label: this.$t("migrating"),
            },
            {
              val: "demo",
              label: this.$t("demo"),
            },
            {
              val: "unknown",
              label: this.$t("unknown"),
            },
            {
              val: "onboarded",
              label: this.$t("onboarded"),
            },
            {
              val: "migrated",
              label: this.$t("migrated"),
            },
            {
              val: "drop_point_only",
              label: this.$t("drop_point_only"),
            },
            {
              val: "external",
              label: this.$t("external"),
            },
            {
              val: "cancelled",
              label: this.$t("cancelled"),
            },
          ],
        },
        {
          name: "payment_method",
          type: "Array",
          value: [
            {
              val: "credit_card",
              label: this.$t("credit_card"),
            },
            {
              val: "invoice",
              label: this.$t("invoice"),
            },
          ],
        },
        {
          name: "payment_extras",
          type: "Array",
          value: [
            {
              val: "missing_credit_card",
              label: this.$t("missing_credit_card"),
            },
            {
              val: "has_overdue_invoices",
              label: this.$t("has_overdue_invoices"),
            },
          ],
        },
        {
          name: "vat_validation_status",
          type: "Array",
          value: [
            {
              val: "ok",
              label: "Ok",
            },
            {
              val: "error",
              label: "Error",
            },
            {
              val: "pending",
              label: "Pending",
            },
          ],
        },
        {
          name: "carrier",
          type: "Array",
          value: this.carriers,
        },
        {
          name: "onboarding_agent",
          type: "Array",
          value: [{ val: null, label: this.$i18n.t("missing") }].concat(
            this.users
          ),
        },
        {
          name: "sales_agent",
          type: "Array",
          value: [{ val: null, label: this.$i18n.t("missing") }].concat(
            this.users
          ),
        },
        {
          name: "customer_success_agent",
          type: "Array",
          value: [{ val: null, label: this.$i18n.t("missing") }].concat(
            this.users
          ),
        },
        {
          name: "order_channel",
          type: "Array",
          value: this.order_channels,
        },
        {
          name: "plan",
          type: "Array",
          value: this.plans,
        },
        {
          name: "tag",
          type: "Array",
          value: this.tags,
        },
        {
          name: "country_code",
          type: "Array",
          value: this.countries,
        },
        {
          name: "dpa_accepted",
          type: "Array",
          value: [
            {
              val: true,
              label: this.$t("true"),
            },
            {
              val: false,
              label: this.$t("false"),
            },
          ],
        },
      ];

      if (this.can("read_organizations")) {
        attrs.push({
          name: "organization",
          type: "Array",
          value: this.organizations,
        });
      }

      return attrs;
    },
  },
  methods: {
    after_mount() {
      Api.findAllPages("tags").then(({ data }) => {
        this.tags = _(data)
          .map((e) => ({ val: e.id, label: e.name }))
          .value();
      });

      if (this.can("read_order_channel_types")) {
        Api.findAllPages("order_channel_types", {
          sort: "name",
          fields: { order_channel_types: "name,id" },
        }).then(({ data }) => {
          this.order_channels = _(data)
            .map((e) => ({ val: e.id, label: e.name }))
            .value();
        });
      }

      if (this.can("read_carrier_types")) {
        Api.findAllPages("carrier_types", {
          sort: "name",
          fields: { carrier_types: "name,id" },
        }).then(({ data }) => {
          this.carriers = _(data)
            .map((e) => ({ val: e.id, label: e.name }))
            .value();
        });
      }

      if (this.can("read_plans")) {
        Api.findAllPages("plans", {
          sort: "name",
          fields: { plans: "name,id" },
        }).then(({ data }) => {
          this.plans = _(data)
            .map((e) => ({ val: e.id, label: e.name }))
            .value();
        });
      }

      if (this.can("read_organizations")) {
        Api.findAllPages("organizations").then(({ data }) => {
          this.organizations = _(data)
            .map((o) => ({ val: o.id, label: o.name }))
            .value();
        });
      }

      if (this.can("read_staffs")) {
        Api.findAllPages("staffs", {
          sort: "first_name",
          fields: { staffs: "first_name,last_name,id" },
        }).then(({ data }) => {
          this.users = _(data)
            .map((e) => ({
              val: e.id,
              label: e.first_name + " " + e.last_name,
            }))
            .value();
        });
      }

      this.countries = Object.entries(countries.getNames(config.locale)).map(
        (country) => {
          return { val: country[0], label: country[1] };
        }
      );
    },
  },
};
</script>
